export default "__VITE_ASSET__BMKVxenP__"